import './product-text.scss';
import { FC } from 'react';

const texts = {
  silver: '',
  gold: '',
  platinum: '',
  emerald: '',
  ruby: '',
};

const subTexts = {
  silver: "LET'S PLAY",
  gold: 'GOLD BONUS',
  platinum: 'PLATINUM BONUS',
  emerald: 'EMERALD BONUS',
  ruby: 'RUBY BONUS',
};

export const ProductText: FC<{
  color: string;
}> = ({ color }) => {
  return (
    <div className='text-wrapper'>
      <span className='top-text'>{texts[color]}</span>
      <span className='bottom-text'>{subTexts[color]}</span>
    </div>
  );
};
